import { IJsonQuery } from '../../types/jsonQuery';
import { getTermValue, TJsonQueryKey } from '../../../../JsonQuery';
import { COMMON_PROPERTIES, RENTAL_PERIOD_SELECTED_OPTIONS } from './constants';

function isCommonPropertiesSelected(jsonQuery: IJsonQuery) {
  return (Object.keys(jsonQuery) as TJsonQueryKey[]).some(
    property => !COMMON_PROPERTIES.includes(property) && jsonQuery[property] !== undefined,
  );
}

function isRentalPeriodSelected(jsonQuery: IJsonQuery) {
  const rentalPeriod = getTermValue('for_day')(jsonQuery);

  return rentalPeriod !== null && RENTAL_PERIOD_SELECTED_OPTIONS.includes(rentalPeriod);
}

export function isAdvancedFiltersSelected(jsonQuery: IJsonQuery): boolean {
  return isCommonPropertiesSelected(jsonQuery) || isRentalPeriodSelected(jsonQuery);
}
